import { getTmsInstance } from '@adeo/tms-lib';
const TMS_EVENT_TYPE = 'cdl_event';
export const eventName = {
  buttonClick: 'button.click',
  stepDisplay: 'step.display',
  stepSubmit: 'step.submit'
};
export const funnelName = {
  rentalReservation: 'rental reservation'
};

/**
 * Push a custom event to the TMS (Piano) data layer.
 * Silently no-ops when the TMS instance is not available so that tracking
 * can never break the booking funnel.
 * @param {string} prmEventName  the cdl event name (e.g. "button.click")
 * @param {Object} prmEventData  the cdl event payload
 */
export function sendTmsEvent(prmEventName, prmEventData) {
  try {
    const tms = getTmsInstance();
    if (!tms || typeof tms.pushEvent !== 'function') {
      return;
    }
    tms.pushEvent(document, TMS_EVENT_TYPE, {
      event_name: prmEventName,
      event_data: prmEventData || {}
    });
  } catch (error) {
    console.error('Failed to push TMS event:', error);
  }
}

/**
 * Push a "button.click" event.
 * @param {string} prmButtonName   value of button_name
 * @param {string} prmButtonValue  value of button_value
 */
export function sendButtonClick(prmButtonName, prmButtonValue) {
  sendTmsEvent(eventName.buttonClick, {
    button_name: prmButtonName,
    button_value: prmButtonValue
  });
}

/**
 * Push a funnel step event ("step.display" or "step.submit").
 * @param {string} prmEventName  the cdl event name
 * @param {string} prmStepName   value of step_name
 */
export function sendStepEvent(prmEventName, prmStepName) {
  sendTmsEvent(prmEventName, {
    funnel_name: funnelName.rentalReservation,
    step_name: prmStepName
  });
}